import React from 'react'
import Header from '../Header/Header'
import PedidosData from '../../components/Admin/PedidosData/PedidosData'
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash'
export default function Productos() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <PedidosData />
                </div>
            </section>
        </div>
    )
}
